import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Input, notification, Divider } from 'antd';
import { push } from 'connected-react-router';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'

// Local
import Text from 'components/Text';
import { post } from 'library/endpoints';
import { validateEmail } from 'utils';

/**
 * Forgot
 * @param {*} props 
 * @returns 
 */
const Forgot = (props) => {
  useEffect(() => {
    if (props.auth.token) {
      props.push('/home')
    }
  })

  useEffect(() => {
    if (props.auth.token) {
      props.push('/home')
    }
  }, [props.auth]) // eslint-disable-line

  const [form, setForm] = useState({
    email: null,
  })

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !validateEmail(form.email)) {
      notification.error({
        message: 'Erreur',
        description: props.t('Admin.Auth.Forgot.SubmitError', 'Vous devez renseigner votre adresse email')
      }); 
    } else {
      await post(`/frontend/auth/forgot`, form);
      notification.success({
        message: 'Succes !',
        description: props.t('Admin.Auth.Forgot.SubmitSuccess', 'Votre nouveau mot de passe vous a été envoyé par mail')
      }); 
      props.push('/')
    }
  }
  
  return (
    <>
      <form style={{ maxWidth: 400, margin: 'auto', marginTop: 40 }} onSubmit={handleOnSubmit}>
        <h1>{props.t('Admin.Auth.Forgot.GetPassword', 'Récupérer mon mot de passe')}</h1>

        <div style={{ height: 20 }} />

        {props.t('Admin.Auth.Forgot.Email', 'Email')}
        <Input type="email" placeholder='Email' onChange={(e) => setForm({...form, email: e.target.value})} />

        <div style={{ height: 20 }} />
        
        <Button 
          type="primary" 
          htmlType="submit" 
          disabled={!validateEmail(form.email)}
        >
          {props.t('Admin.Auth.Forgot.Button', 'Récupérer mon mot de passe')}
        </Button>
      </form>

      <Divider>ou</Divider>
      
      <Text align="center">
        <Link to={props.location.search.includes('franchise') ? `/auth-franchise` : `/`}>{props.t('Admin.Auth.Forgot.LoginLink', `S'identifier`)}</Link>
      </Text>
    </>
  )
}

const stateToProps = state => ({
  auth: state.auth,
})

const dispatchToProps = {
  push
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(Forgot));